// ── Backend API calls ──────────────────────────────────────────────────────
// All sensitive operations go through the Flask backend at
// poextraction.softglowlab.com — tokens never touch the browser.

const API_BASE   = process.env.REACT_APP_API_BASE   || 'https://poextraction.softglowlab.com';
const API_KEY    = process.env.REACT_APP_CONTRACT_API_KEY || '';

function authHeaders() {
  return {
    'Content-Type': 'application/json',
    ...(API_KEY ? { 'X-Api-Key': API_KEY } : {}),
  };
}

// ── Send contract email via Flask → Gmail ──────────────────────────────────
export async function sendContractEmailViaBackend({ formData, pdfDoc }) {
  const pdfBase64  = pdfDoc.output('datauristring').split(',')[1];
  const safeName   = (formData.custName || 'Customer').replace(/[^a-zA-Z0-9_ -]/g, '').trim();
  const filename   = `SoftGlow_Agreement_${safeName.replace(/\s+/g, '_')}.pdf`;

  const res = await fetch(`${API_BASE}/api/send-contract-email`, {
    method:  'POST',
    headers: authHeaders(),
    body: JSON.stringify({
      to_email:       formData.custEmail,
      customer_name:  formData.custName,
      signatory_name: formData.custSigName || formData.custName,
      pdf_base64:     pdfBase64,
      pdf_filename:   filename,
      cc_email:       formData.senderEmail || 'sales@softglowlab.com',
    }),
  });

  const data = await res.json();
  if (!data.ok) throw new Error(data.error || `Email API error ${res.status}`);
  return data;
}

// ── Create Zoho contact via Flask → Zoho Inventory ────────────────────────
export async function createZohoContactViaBackend(formData) {
  const res = await fetch(`${API_BASE}/api/create-zoho-contact`, {
    method:  'POST',
    headers: authHeaders(),
    body: JSON.stringify(formData),
  });

  const data = await res.json();
  if (!data.ok) throw new Error(data.error || `Zoho API error ${res.status}`);
  return data;
}
